import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';

import './editable-input.scss';
import { NO_OP } from '../../../constants';

export default function EditableInput({ value, className, onBlur = NO_OP, editOnMount = false }) {
  const [editMode, setEditMode] = useState(editOnMount);
  const [inputData, setInputData] = useState(value);
  const inputRef = useRef();

  // Select text on mount
  useEffect(() => {
    if (!editOnMount || !inputRef.current) return;

    inputRef.current.select();
  }, [inputRef, editOnMount]);

  const handleBlur = () => {
    setEditMode(false);
    onBlur(inputData);
  };

  const handleClick = () => {
    setEditMode(true);
  };

  const handleInputChange = (e) => {
    setInputData(e.target.value);
  };

  const renderInput = () => {
    return (
      <input
        ref={inputRef}
        type="text"
        value={inputData}
        autoFocus={true}
        onBlur={handleBlur}
        onChange={handleInputChange}
      />
    );
  };

  const renderLabel = () => {
    return (
      <div className="view" onClick={handleClick}>
        {value}
      </div>
    );
  };

  return (
    <div className={classnames('editable-input', className, { edit: editMode })}>
      {editMode ? renderInput() : renderLabel()}
    </div>
  );
}
